import DOMPurify from 'dompurify';

// Embeds the article editor (Quill) can produce; any other iframe source is dropped.
const ALLOWED_EMBED = /^https:\/\/(www\.youtube(-nocookie)?\.com|player\.vimeo\.com)\//i;

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'IFRAME' && !ALLOWED_EMBED.test(node.getAttribute('src') || '')) {
    node.remove();
  }
  // links that open a new tab must not hand it a handle back to this page
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Everything shown with dangerouslySetInnerHTML goes through here: trip and article text is written
// by users, and the session token lives in localStorage, so one injected <script>/onerror= is an account takeover.
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html == null ? '' : String(html), {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'target']
  });
